var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import { Icon } from "../../Icon";
import styled from "styled-components";
import { marginCss } from "../../../../styles/margin";
var iconSizes = {
    small: "15",
    medium: "15",
    large: "20",
};
var IconWrapper = function (_a) {
    var children = _a.children, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, size = _a.size;
    return (React.createElement(React.Fragment, null,
        leftIcon && (React.createElement(StyledIcon, { marginInlineEnd: "0.5rem", name: leftIcon, fill: "currentColor", width: iconSizes[size], height: iconSizes[size] })),
        children,
        rightIcon && (React.createElement(StyledIcon, { marginInlineStart: "0.5rem", name: rightIcon, fill: "currentColor", width: iconSizes[size], height: iconSizes[size] }))));
};
var StyledIcon = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), marginCss);
export default IconWrapper;
var templateObject_1;
